// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"6715d983","180":"35a26b79","237":"4f60078e","286":"ca1ed685","453":"03346f77","467":"ee2a564e","472":"5047bfea","535":"c8ed9216","595":"057f0f51","610":"fcd0e415","718":"009b83f2","783":"b4f1fc01","874":"b8b86afd"}[chunkId] + ".chunk.js";
};